import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import Loader from '../../components/Loader';
import { useQuizRegisterMutation } from '../../slices/fun_stuff/quizUsersSlice';
import { setQuizCredentials } from '../../slices/fun_stuff/quizAuthSlice';
import { toast } from 'react-toastify';

const QuizRegister = ({ setShow }) => {
  const [username, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');

  const dispatch = useDispatch();

  const [ quizRegister, { isLoading }] = useQuizRegisterMutation();
  
  const submitHandler = async (e) => {
    e.preventDefault();
    if(password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    } else {
      try {
        const res = await quizRegister({ username, password, email }).unwrap();
        dispatch(setQuizCredentials({...res, }));
        setShow(false);
      } catch (error) {
        toast.error(error?.data?.message || error.error);
      }
    }
  }

  return (
    <div>
      <h2 className='mt-3'>Register</h2>

      <Form onSubmit={submitHandler}>
        <Form.Group controlId='name' className='my-1' style={{ maxWidth: '250px' }}>
          <Form.Label>Username</Form.Label>
          <Form.Control 
            type='text'
            placeholder='Enter Username'
            onChange={(e) => setUserName(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId='password' className='my-1' style={{ maxWidth: '250px' }}>
          <Form.Label>Password</Form.Label>
          <Form.Control 
            type='password'
            placeholder='Enter password'
            onChange={(e) => setPassword(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId='confirmPassword' className='my-1' style={{ maxWidth: '250px' }}>
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control 
            type='password'
            placeholder='Confirm password'
            onChange={(e) => setConfirmPassword(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId='email' className='my-1' style={{ maxWidth: '250px' }}>
          <Form.Label>Email
            <p className='my-0'>*optional, only used for password reset</p></Form.Label>
          <Form.Control 
            type='email'
            placeholder='Email (optional)'
            onChange={(e) => setEmail(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Button type='submit' className='quiz-btn-dark mt-2' disabled={ isLoading }>
          Register for Quiz Game
        </Button>

        { isLoading && <Loader /> }
        
      </Form>
    </div>
  )
}

export default QuizRegister
